//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import card from './components/card.vue'
import { personIntegral } from '@/api/lalisai'
export default {
  name: 'detail',
  components: {
    card
  },
  props: {},
  data () {
    return {
      title: '助力值明细',
      partyId: '1',
      detaillist: [],
      typename: ''
    }
  },
  created () { },
  mounted () {
    this.getlist()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  methods: {
    getlist () {
      personIntegral({
        partyId: this.partyId,
        accountid: this.accountid
      }).then(data => {
        this.detaillist = data.obj
        this.detaillist.forEach(el => {
          if (el.type == 1 || el.type == 16) {
            this.$set(el, 'typename', '每日线上答题')
          } else if (el.type == 2 || el.type == 17) {
            this.$set(el, 'typename', '周六挑战答题')
          } else if (el.type == 3 || el.type == 18) {
            this.$set(el, 'typename', '邀请好友参与')
          } else if (el.type == 4) {
            this.$set(el, 'typename', '首次参与活动')
          } else if (el.type == 5) {
            this.$set(el, 'typename', '首次提交收货地址')
          } else if (el.type == 6) {
            this.$set(el, 'typename', '拉人入队')
          } else if (el.type == 7 || el.type == 8 || el.type == 9) {
            this.$set(el, 'typename', '每日答题额外助力值领取')
          } else if (el.type == 10 || el.type == 11 || el.type == 12) {
            this.$set(el, 'typename', '周六挑战答题额外助力值领取')
          } else if (el.type == 13 || el.type == 14 || el.type == 15) {
            this.$set(el, 'typename', '邀请好友额外助力值领取')
          }
        })
      })
    }
  }
}
